// AboutIntro.js
import React from 'react';
import { motion } from 'framer-motion';

const AboutIntro = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <p className="text-lg md:text-xl text-gray-700 font-light leading-relaxed mb-6">
              Ivipass helps people weigh up the realities of studying or taking a job in another country. We work case by case: understanding where someone actually stands, explaining what a given route demands of them, and staying alongside them through the paperwork and the waiting.
            </p>
            <p className="text-lg md:text-xl text-gray-700 font-normal leading-relaxed">
              Careful preparation, frank assessment, and results that still make sense years later are what we measure ourselves against.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;
